const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Espa\xF1ol" },
  { code: "pt", label: "Portugu\xEAs" },
  { code: "fr", label: "Fran\xE7ais" },
  { code: "de", label: "Deutsch" },
  { code: "nl", label: "Nederlands" },
  { code: "it", label: "Italiano" },
  { code: "ja", label: "\u65E5\u672C\u8A9E" },
  { code: "ko", label: "\uD55C\uAD6D\uC5B4" },
  { code: "tr", label: "T\xFCrk\xE7e" },
  { code: "da", label: "Dansk" },
  { code: "hi", label: "\u0939\u093F\u0928\u094D\u0926\u0940" },
  { code: "ar", label: "\u0639\u0631\u0628\u064A" },
  { code: "zh-HK", label: "\u4E2D\u6587 (\u9999\u6E2F)" },
  { code: "zh-CN", label: "\u4E2D\u6587 (\u7B80\u4F53)" }
];
const LOCALES = LANGUAGES.map((l) => l.code);
const LOCALES_ISO_639_3 = {
  en: "eng",
  // English
  es: "spa",
  // Spanish
  pt: "por",
  // Portuguese
  fr: "fra",
  // French
  de: "deu",
  // German
  nl: "nld",
  // Dutch
  it: "ita",
  // Italian
  ja: "jpn",
  // Japanese
  ko: "kor",
  // Korean
  tr: "tur",
  // Turkish
  da: "dan",
  // Danish
  hi: "hin",
  // Hindi
  ar: "ara",
  // Generic Arabic
  "zh-HK": "yue",
  // Cantonese
  "zh-CN": "zho"
  // Mandarin
};
const DEFAULT_LOCALE = "en";
const DEFAULT_NS = "common";
const NAMESPACES = ["common", "zod"];
export {
  DEFAULT_LOCALE,
  DEFAULT_NS,
  LANGUAGES,
  LOCALES,
  LOCALES_ISO_639_3,
  NAMESPACES
};
//# sourceMappingURL=constants.js.map